"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var TreeNode_1 = require("./TreeNode");
var checktree_1 = require("../checktree");
var TreeContext_1 = require("./TreeContext");
var use_default_1 = require("../_util/use-default");
var is_child_of_type_1 = require("../_util/is-child-of-type");
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var VirtualizedTreeList_1 = require("./VirtualizedTreeList");
var Tree_1 = require("./deprecated/Tree");
var util_1 = require("./util");
var noop_1 = require("../_util/noop");
/**
 * 构造树节点
 */
function renderTree(data, level, pid, pPathKey) {
    var nodes = [];
    var relations = {};
    var disabledIds = [];
    data.forEach(function (_a) {
        var children = _a.children, id = _a.id, disableSelect = _a.disableSelect, props = tslib_1.__rest(_a, ["children", "id", "disableSelect"]);
        var pathKey = pid ? pPathKey + "$" + id : id;
        nodes.push(tslib_1.__assign(tslib_1.__assign({}, props), { level: level,
            id: id,
            children: children,
            disableSelect: disableSelect,
            pathKey: pathKey }));
        if (pid) {
            relations[id] = pid;
        }
        if (disableSelect) {
            disabledIds.push(id);
        }
        if (children && children.length > 0) {
            var childInfo = renderTree(children, level + 1, id, pathKey);
            // 合并子级信息
            childInfo.nodes.forEach(function (i) { return nodes.push(i); });
            childInfo.disabledIds.forEach(function (i) { return disabledIds.push(i); });
            Object.entries(childInfo.relations).forEach(function (_a) {
                var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
                relations[key] = value;
            });
        }
    });
    return { nodes: nodes, relations: relations, disabledIds: disabledIds };
}
/**
 * TreeNode -> Data
 */
function getTreeData(children) {
    var data = [];
    react_1.default.Children.forEach(children, function (child) {
        if (is_child_of_type_1.isChildOfType(child, TreeNode_1.TreeNode)) {
            var props = tslib_1.__assign(tslib_1.__assign({}, child.props), { children: child.props.children
                    ? getTreeData(child.props.children)
                    : null });
            data.push(props);
        }
    });
    return data;
}
exports.Tree = forward_ref_with_statics_1.forwardRefWithStatics(function Tree(props, ref) {
    var isValid = react_1.useMemo(function () { return util_1.checkTreeNode(props.children); }, [
        props.children,
    ]);
    if (!isValid) {
        return react_1.default.createElement(Tree_1.Tree, tslib_1.__assign({}, props, { ref: ref }));
    }
    return react_1.default.createElement(TreeInner, tslib_1.__assign({}, props, { ref: ref }));
}, {
    Node: TreeNode_1.TreeNode,
});
exports.Tree.displayName = "Tree";
var TreeInner = react_1.forwardRef(function TreeInner(_a, ref) {
    var _b;
    var data = _a.data, children = _a.children, selectable = _a.selectable, selectedIds = _a.selectedIds, _c = _a.defaultSelectedIds, defaultSelectedIds = _c === void 0 ? [] : _c, selectStrictly = _a.selectStrictly, onSelect = _a.onSelect, _d = _a.selectValueMode, selectValueMode = _d === void 0 ? "all" : _d, fullActivable = _a.fullActivable, _e = _a.activable, activable = _e === void 0 ? fullActivable : _e, activeIds = _a.activeIds, _f = _a.defaultActiveIds, defaultActiveIds = _f === void 0 ? [] : _f, onActive = _a.onActive, expandedIds = _a.expandedIds, _g = _a.defaultExpandedIds, defaultExpandedIds = _g === void 0 ? [] : _g, _h = _a.onExpand, onExpand = _h === void 0 ? noop_1.noop : _h, fullExpandable = _a.fullExpandable, defaultExpandAll = _a.defaultExpandAll, _j = _a.defaultExpandParent, defaultExpandParent = _j === void 0 ? true : _j, forceExpandParent = _a.forceExpandParent, onLoad = _a.onLoad, onLoadError = _a.onLoadError, switcherIcon = _a.switcherIcon, className = _a.className, height = _a.height, props = tslib_1.__rest(_a, ["data", "children", "selectable", "selectedIds", "defaultSelectedIds", "selectStrictly", "onSelect", "selectValueMode", "fullActivable", "activable", "activeIds", "defaultActiveIds", "onActive", "expandedIds", "defaultExpandedIds", "onExpand", "fullExpandable", "defaultExpandAll", "defaultExpandParent", "forceExpandParent", "onLoad", "onLoadError", "switcherIcon", "className", "height"]);
    var _k = react_1.useMemo(function () { return renderTree(data || getTreeData(children), 0); }, [children, data]), nodes = _k.nodes, relations = _k.relations, disabledIds = _k.disabledIds;
    // 选择关系和结构关系可能不同
    var selectRelations = react_1.useMemo(function () { return (selectStrictly ? {} : relations); }, [
        relations,
        selectStrictly,
    ]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _l = tslib_1.__read(use_default_1.useDefault(selectedIds, defaultSelectedIds, onSelect), 2), selectedNodes = _l[0], setSelectedNodes = _l[1];
    var _m = tslib_1.__read(use_default_1.useDefault(activeIds, defaultActiveIds, onActive), 2), activeNodes = _m[0], setActiveNodes = _m[1];
    var _o = tslib_1.__read(use_default_1.useDefault(expandedIds, util_1.getDefaultExpandedIds({
        relations: relations,
        expandedIds: expandedIds,
        defaultExpandedIds: defaultExpandedIds,
        defaultExpandAll: defaultExpandAll,
        defaultExpandParent: defaultExpandParent,
        forceExpandParent: forceExpandParent,
    }), onExpand), 2), rawExpandedNodes = _o[0], setExpandedNodes = _o[1];
    var expandedNodes = react_1.useMemo(function () {
        if (forceExpandParent) {
            var idSet_1 = new Set(rawExpandedNodes);
            rawExpandedNodes.forEach(function (id) {
                var child = id;
                while (child in relations && !idSet_1.has(relations[child])) {
                    idSet_1.add(relations[child]);
                    child = relations[child];
                }
            });
            return tslib_1.__spread(idSet_1);
        }
        return rawExpandedNodes;
    }, [forceExpandParent, rawExpandedNodes, relations]);
    var visibleNodes = react_1.useMemo(function () {
        return nodes.filter(function (_a) {
            var id = _a.id;
            return util_1.getNodeShowState(id, relations, expandedNodes);
        });
    }, [expandedNodes, nodes, relations]);
    var _p = tslib_1.__read(react_1.useMemo(function () { return (height ? [VirtualizedTreeList_1.VirtualizedTreeList, { height: height }] : [TreeList, {}]); }, [height]), 2), List = _p[0], ListProps = _p[1];
    var handleActive = react_1.useCallback(function (activeId, event, data) {
        return setActiveNodes([activeId], {
            active: true,
            nodeId: activeId,
            event: event,
            data: data,
        });
    }, [setActiveNodes]);
    var handleExpand = react_1.useCallback(function (nodeId, expanded, event, data) {
        return setExpandedNodes(function (rawExpandedNodes) {
            var expandedNodes = rawExpandedNodes || [];
            if (forceExpandParent) {
                var idSet_2 = new Set(rawExpandedNodes);
                rawExpandedNodes.forEach(function (id) {
                    var child = id;
                    while (child in relations && !idSet_2.has(relations[child])) {
                        idSet_2.add(relations[child]);
                        child = relations[child];
                    }
                });
                expandedNodes = tslib_1.__spread(idSet_2);
            }
            return expanded
                ? tslib_1.__spread(expandedNodes, [nodeId]) : expandedNodes.filter(function (id) { return id !== nodeId; });
        }, { nodeId: nodeId, expanded: expanded, event: event, data: data });
    }, [forceExpandParent, relations, setExpandedNodes]);
    var handleSelectChange = react_1.useCallback(function (value, _a) {
        var check = _a.check, event = _a.event;
        return setSelectedNodes(value, {
            nodeId: check.name,
            selected: check.value,
            event: event,
        });
    }, [setSelectedNodes]);
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-tree", className, (_b = {},
            _b[classPrefix + "-tree--checkbox-separate"] = selectable && activable,
            _b[classPrefix + "-tree--full-line"] = fullExpandable || fullActivable,
            _b)) }, props),
        react_1.default.createElement(TreeContext_1.TreeContext.Provider, { value: {
                flatten: true,
                selectable: selectable,
                activable: activable,
                activeIds: activeNodes,
                expandedIds: expandedNodes,
                onActive: handleActive,
                onExpand: handleExpand,
                onLoad: onLoad,
                onLoadError: onLoadError,
                switcherIcon: switcherIcon,
                fullExpandable: fullExpandable,
                fullActivable: fullActivable,
            } }, selectable ? (react_1.default.createElement(checktree_1.CheckTree, { valueMode: selectValueMode, relations: selectRelations, value: selectedNodes, disabledNames: disabledIds, onChange: handleSelectChange },
            react_1.default.createElement(List, tslib_1.__assign({ nodes: visibleNodes }, ListProps), visibleNodes))) : (react_1.default.createElement(List, tslib_1.__assign({ nodes: visibleNodes }, ListProps), visibleNodes)))));
});
TreeInner.displayName = "TreeInner";
function TreeList(_a) {
    var nodes = _a.nodes;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _b = react_1.useContext(TreeContext_1.TreeContext), activable = _b.activable, activeIds = _b.activeIds;
    return (react_1.default.createElement("ul", null, nodes.map(function (_a) {
        var _b;
        var pure = _a.pure, _c = _a.style, style = _c === void 0 ? {} : _c, className = _a.className, height = _a.height, pathKey = _a.pathKey, props = tslib_1.__rest(_a, ["pure", "style", "className", "height", "pathKey"]);
        return (react_1.default.createElement("li", { key: pathKey || props.id, className: classnames_1.default(classPrefix + "-tree__node", className, (_b = {
                    // 高亮
                    "is-selected": activable && activeIds.includes(props.id)
                },
                _b[classPrefix + "-tree__node--transparent"] = pure,
                _b)), style: tslib_1.__assign({ height: height }, style) },
            react_1.default.createElement(TreeNode_1.TreeNode, tslib_1.__assign({}, props))));
    })));
}
//# sourceMappingURL=Tree.js.map